import { environment } from '../../environments/environment';

/**
 * Base URL of the online-quote-tool application, used by the online courses
 * wayfinder banner to build the link users are redirected to.
 *
 * Defined per build environment (dev/stage/prod) since it points to a
 * different deployment of online-quote-tool in each one.
 */
export const getOnlineQTBaseUrl = () => environment.ONLINE_QT_BASE_URL;
